import md5 from "js-md5";
import Vue from "vue";

Vue.prototype.$ajax = function (path, params) {
  let userdata = Vue.prototype.$fn.getUserData();

  let url = process.env.VUE_APP_BASEURL;

  let sign; // 定义验签字段

  let appId = "uN7fJ3eKlJZBrVJXpZnm9A";

  let appSecret = "5e02a319495e4a3685153cc1150d265d";

  let ts = new Date().getTime();

  let tokEn = userdata ? userdata.tokEn : null;

  let memId = userdata ? userdata.memId : null;

  let urlpath = path.replace("iap-", "");

  path.indexOf("iap-mapi") != -1
    ? (sign = md5(
        appId + ts + tokEn + memId + ts + tokEn + appSecret + url + urlpath
      ))
    : (sign = md5(ts + appId + appSecret + appSecret + url + urlpath));

  return new Promise(function (resolve, reject) {
    Vue.prototype
      .$axios({
        method: "POST",

        timeout: 7000, //超时时间设置，单位毫秒

        url: url + path + "?ts=" + ts + "&appId=" + appId,

        headers: {
          sIgn:
            userdata == null
              ? sign
              : sign +
                "," +
                userdata.memId +
                "," +
                md5(
                  appId +
                    ts +
                    userdata.tokEn +
                    userdata.memId +
                    ts +
                    userdata.tokEn +
                    appSecret +
                    url +
                    urlpath
                ),
        },

        contentType: "application/json; charset=utf-8",

        data: params,
      })
      .then((res) => {
        res.data["params"] = params;
        if (res.status == 200) {
          if (params.resall == true) {
            return resolve(res.data);
          } else if (params.req) {
            return resolve(res.data);
          } else if (res.data.meta.res == "00000") {
            return resolve(res.data);
          } else if (res.data.meta.res == "10006" || res.data.meta.res == "21008") {
            reject(res.data)
            //token失效
            Vue.prototype.$toastUtil.show(res.data.meta.msg)
            //退出登陆
            Vue.prototype.$fn.quit();
            //跳转登陆页面
            Vue.prototype.$router.path('/login')
            return;
          } else {
            reject(res.data)
            Vue.prototype.$dialog
              .alert({
                message: res.data.meta.msg,
              })
              .then(() => {});
            return;
          }
        }
      })
      .catch((error) => {
        reject(error.message)
        Vue.prototype.$dialog
          .alert({
            message: error.message,
          })
          .then(() => {});
      });
  });
};
